"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListenersMap = void 0;

var ListenersMap =
/** @class */
function () {
  function ListenersMap() {
    var _this = this; // Using a Map to store a Set of _listeners so that we can remove _listeners in constant time


    this._listeners = new Map();

    this.delete = function (key) {
      return _this._listeners.delete(key);
    };

    this.get = function (key) {
      return _this._listeners.get(key);
    };
  }

  ListenersMap.prototype.add = function (key, listener) {
    var _a;

    if (!this._listeners.has(key)) {
      this._listeners.set(key, new Set());
    }

    (_a = this._listeners.get(key)) === null || _a === void 0 ? void 0 : _a.add(listener);
  };

  return ListenersMap;
}();

exports.ListenersMap = ListenersMap;